// @flow
import React from 'react';
import type { Node } from 'react';
import type { IntlShape } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../../../components/shared/Icons/Icon';
import messages from '../../../../messages';
import Button from '../../../../../common/forms/Button';
import styles from './styles';
import { animationDuration } from '../../../../../themes';

const { filtersTitle, filtersClear, filtersShowResults } = messages;

type Props = {
  children: Node,
  onClearFilters: Function,
  hideFilters: Function,
  showing: boolean,
  intl: IntlShape,
  count: number,
  isFetching: boolean,
  animated: boolean,
};

type State = {
  showing: boolean,
  mustBeShown: boolean,
};

class FormFilter extends React.PureComponent<Props, State> {
  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (nextProps.showing) {
      return {
        showing: true,
      };
    }
    if (!nextProps.showing && prevState.showing !== nextProps.showing) {
      return {
        mustBeShown: false,
      };
    }
    return null;
  }

  state = {
    showing: this.props.showing,
    mustBeShown: this.props.showing,
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.showing && prevState.showing !== this.state.showing) {
      this.showForm();
    }
    if (!this.state.mustBeShown && prevState.mustBeShown !== this.state.mustBeShown) {
      this.hideForm();
    }
  }

  showForm() {
    const newState = {
      mustBeShown: true,
    };
    if (!this.props.animated) {
      return this.setState(newState);
    }

    // Delay to add 'shown' class and apply open filters animation
    return setTimeout(() => {
      this.setState(newState);
    }, 50);
  }

  hideForm() {
    const newState = {
      showing: false,
      mustBeShown: false,
    };

    if (!this.props.animated) {
      return this.setState(newState);
    }

    // Delay to remove 'shown' class and apply open filters animation
    return setTimeout(() => {
      this.setState(newState);
    }, animationDuration.fast * 1000);
  }

  render() {
    const { children, hideFilters, onClearFilters, intl, count, isFetching, animated } = this.props;
    return this.state.showing ? (
      <form
        className={`${animated ? ' animated' : ''} ${this.state.mustBeShown ? ' shown' : ''}`}
        data-test="filters"
      >
        <div className="header">
          <span className="title">
            <FormattedMessage {...filtersTitle} />
          </span>
          <a className="cancel" onClick={hideFilters}>
            <Icon type="previous" fill="#FFFFFF" width={24} />
          </a>
          <a className="clear" onClick={onClearFilters}>
            <FormattedMessage {...filtersClear} />
          </a>
        </div>
        {children}
        <div className="buttons">
          <Button
            id="show-results-button"
            color="blue"
            size="big"
            fullWidth
            onClick={hideFilters}
            title={intl.formatMessage(filtersShowResults, { '%s': count || '0' })}
            isDisabled={!(count > 0)}
          />
        </div>
        {isFetching && <div className="fetching" />}
        <style jsx>{styles}</style>
      </form>
    ) : null;
  }
}

export default FormFilter;



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/Form/component.js